/**
 * Created by coolguy on 2017/11/17.
 */
import NetUtil from '../utils/ajax';
import {observable,action} from 'mobx';
export default class MyStore{
    @observable my = {};
    constructor(rootStore){
        this.rootStore = rootStore;
    }
    galleryList(option={}) {
        const {page=1,order="desc",galleryname} = option;
        return NetUtil.get('/api/usergallery/list',{data:{
            page,
            order,
            galleryname,
        }}).then(action(res => {
                return res;
            }));
    }
    favoriteList(option={}) {
        const {page=1,order="desc",galleryname} = option;
        return NetUtil.get('/api/userimage/lovelist',{data:{
            page,
            order,
            galleryname,
        }}).then(action(res=>{
            return res;
        }))
    }
    //id  图片id,  galleryid 相册id, path 图片地址
    sendLove({id,galleryid,path}) {
        if(!(id&&galleryid&&path)){
            console.error("数据异常，请检查数据",id,galleryid,path);
            return;
        }
        return NetUtil.post("/api/userimage/love",{data:{
            id,galleryid,path
        }}).then(res=>(res));
    }
    addToGallery(id) {
        if(!id){
            console.error("参数异常")
            return;
        }
        return NetUtil.post("/api/usergallery/add",{data:{
            id
        }}).then(res=>(res))
    }
}


// WEBPACK FOOTER //
// ./src/store/MyStore.js